export interface AddProductToWishListRequest {
  comments: string;
  qty: number;
  sku: string;
  wishlistId: number;
}
export interface RemoveProductFromWishListRequest {
  wishListId: number;
  wishListItemId: number;
}

export enum WishListProductAction {
  ADD = 'add',
  REMOVE = 'remove',
}